import React, { useEffect, useState } from 'react';
import { getPosts } from '../api';
import PostCard from '../components/PostCard';

export default function Home({ settings }) {
  const [posts, setPosts] = useState([]);

  useEffect(() => { getPosts().then(setPosts).catch(() => {}); }, []);

  return (
    <>
      {/* Profile Header */}
      <div className="profile-header">
        <div className="profile-avatar">
          {settings.logo_circular_url || settings.logo_url
            ? <img src={settings.logo_circular_url || settings.logo_url} alt="logo" />
            : '🎬'}
        </div>
        <div className="profile-info">
          <h1><span>{settings.site_title}</span></h1>
          <div className="profile-stats">
            <div><strong>{posts.length}</strong><span>publicaciones</span></div>
          </div>
          <div className="profile-bio">
            Producción audiovisual · Creatividad sin límites
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="feed-tabs">
        <button className="active">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
            <rect x="2" y="2" width="9" height="9"/><rect x="13" y="2" width="9" height="9"/>
            <rect x="2" y="13" width="9" height="9"/><rect x="13" y="13" width="9" height="9"/>
          </svg>
          PUBLICACIONES
        </button>
      </div>

      {/* Grid */}
      {posts.length === 0 ? (
        <div className="empty-state">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/>
            <polyline points="21 15 16 10 5 21"/>
          </svg>
          <p>No hay publicaciones aún</p>
        </div>
      ) : (
        <div className="feed-grid">
          {posts.map(p => <PostCard key={p.id} post={p} settings={settings} />)}
        </div>
      )}
    </>
  );
}
